import { useCallback, useEffect, useMemo, useState } from "react";
import { AxiosRequest } from "_services/api";
import { IOptions } from "components/DropdownSelect";

export function useUsuariosTaxa() {
  const msAw = useMemo(
    () => AxiosRequest.makeApi(process.env.REACT_APP_MS_AW),
    [],
  );
  const [usuariosOptions, setUsuariosOptions] = useState<IOptions[]>([]);

  const listar = useCallback(async () => {
    try {
      const { data } = await msAw.get("/financeiro/pagamento-taxa/lote/usuarios");
      const lista = Array.isArray(data) ? data : (data?.dados ?? []);
      setUsuariosOptions(
        lista.map((u: any) => ({ value: u.id, label: u.nome })),
      );
    } catch {
      setUsuariosOptions([]);
    }
  }, [msAw]);

  useEffect(() => {
    listar();
  }, [listar]);

  return { usuariosOptions };
}
